var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, Route, useHistory } from 'react-router-dom';
import useAuthentication from '../../hooks/useAuthentication';
var PrivateRoute = function (_a) {
  var component = _a.component,
    path = _a.path,
    rest = __rest(_a, ["component", "path"]);
  var isAuthenticated = useAuthentication().isAuthenticated;
  var history = useHistory();
  // need to assume component exists... thanks TS 👎
  var Component = component;
  var render = function (props) {
    return isAuthenticated === true ? _jsx(Component, __assign({}, props)) : _jsx(Redirect, {
      to: {
        pathname: '/login',
        state: {
          from: history.location
        }
      }
    });
  };
  return _jsx(Route, __assign({
    path: path,
    render: render
  }, rest));
};
export default PrivateRoute;